import { SmartFeedEntityDynamicElementMixin } from "%/dynamic-component-editor/mixins/smart-feed-entity-dynamic-element-mixin";
import { useCommentStore } from "%/dynamic-component-editor/stores/comment-store";

const EMPTY_COMMENT_ENTITY = Object.freeze({
  message_id: 0,
  conversation_id: 0,
  author_name: "",
  avatar_url: "",
  message: "",
  status: "",
  parent_id: 0,
  num_likes: 0,
  num_approved_replies: 0,
  reactions: [],
  replies: [],
  timestamp_created: 0,
  timestamp_updated: 0,
});

// CommentPage element host. Routes Comment elements through the
// comment-store so production reads the URL-derived message_id (via
// pageEntities.comment) and lazy-fetches the message record.
export const CommentPageElementMixin = {
  extends: SmartFeedEntityDynamicElementMixin,
  inject: {
    pageEntities: { default: null },
    useExampleData: { default: () => () => false },
  },
  entityStore: () => useCommentStore(),
  created() {
    if (this.editMode || this.isPreviewMode) {
      return;
    }
    const id = this.commentEntityId;
    if (!id) {
      return;
    }
    useCommentStore().getOrFetchComment(id).catch(error => {
      // eslint-disable-next-line no-console
      console.error("A comment page could not load its comment, so it shows none", { messageId: id, error });
    });
  },
  computed: {
    isPreviewMode() {
      const fn = this.useExampleData;
      return typeof fn === "function" ? Boolean(fn()) : Boolean(fn);
    },
    commentEntityId() {
      if (this.entityId !== undefined && this.entityId !== null && this.entityId !== 0 && this.entityId !== "0") {
        return this.entityId;
      }
      const fromPage = typeof this.pageEntities === "function" ? this.pageEntities()?.comment : this.pageEntities?.comment;
      return fromPage ?? 0;
    },
  },
  methods: {
    getExampleEntity() {
      return {
        author_name: "John Doe",
        avatar_url: "",
        conversation_id: 1,
        message: "This is a sample comment message",
        message_id: 1,
        moderation_status: "approved",
        num_approved_replies: 2,
        num_likes: 0,
        parent_id: 0,
        reactions: [],
        status: "active",
        replies: [],
        timestamp_created: 1742998964,
        timestamp_updated: 1743072285,
      };
    },
    getRealEntity() {
      if (this.isPreviewMode) {
        return this.getExampleEntity();
      }
      const id = this.commentEntityId;
      if (!id) {
        return EMPTY_COMMENT_ENTITY;
      }
      const cached = useCommentStore().comments?.[id];
      if (cached && (cached.message_id || cached.messageId)) {
        return cached;
      }
      return EMPTY_COMMENT_ENTITY;
    },
  },
};
